// Function for text-area count
(function($) {

        $.fn.charCount = function(options){

            // default configuration properties
            var defaults = {
                allowed: 100,
                warning: 25,
                css: 'counter',
                counterElement: 'span',
                cssWarning: 'warning',
                cssExceeded: 'danger',
                counterText: ''
            };

            var options = $.extend(defaults, options);

            function calculate(obj){
                var count = $(obj).val().length;
                var available = options.allowed - count;
                if(available <= options.warning && available >= 0){
                    $(obj).next().addClass(options.cssWarning);
                } else {
                    $(obj).next().removeClass(options.cssWarning);
                }
                if(available < 0){
                    $(obj).next().addClass(options.cssExceeded);
                    /* disabling submit button

                    $('input[type="submit"]').attr('disabled', 'disabled');

                    */
                } else {
                    $(obj).next().removeClass(options.cssExceeded);
                }
                $(obj).next().html(options.counterText + available);
            }

            this.each(function() {
                $(this).after('<'+ options.counterElement +' class="' + options.css + '">'+ options.counterText +'</'+ options.counterElement +'>');
                calculate(this);
                $(this).keyup(function(){calculate(this);});
                $(this).change(function(){calculate(this);});
            });

        };

})(jQuery);


$(document).ready(function() {

    var limit = 500;

    if ($('.count-char').data('limit')){
        limit = $('.count-char').data('limit');
    }

    if($('.count-char').length > 0){
        $('.count-char').charCount({
            allowed:limit
        });
    }

    if($('.count-char-title').length > 0){
        $('.count-char-title').charCount({
            allowed:160
        });
    }

    if($('.count-char-report').length > 0){
        $('.count-char-report').charCount({
            allowed:250
        });
    }

});




// WEBPACK FOOTER //
// ./resources/assets/themes/default/js/counter.js